import { render, staticRenderFns } from "./WorkingoutExerciseNote.vue?vue&type=template&id=31a22603&scoped=true"
import script from "./WorkingoutExerciseNote.vue?vue&type=script&lang=js"
export * from "./WorkingoutExerciseNote.vue?vue&type=script&lang=js"
import style0 from "./WorkingoutExerciseNote.vue?vue&type=style&index=0&id=31a22603&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a22603",
  null
  
)

export default component.exports